module.exports = __webpack_public_path__ + "static/media/3_NES_AP_Z1.827453b1.png";